export default "__VITE_ASSET__BI0$kz7A__"